import { CloseOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { useCallback } from "react";

type Props = {
  isAdding: boolean;
  isDirty: boolean;
  name: string;
  onBack: () => void;
};

export const EditorBackButton: React.FC<Props> = ({
  isAdding,
  isDirty,
  name,
  onBack,
}) => {
  const { modal } = App.useApp();
  const goBack = useCallback(() => {
    if (isDirty) {
      modal.confirm({
        content: "You have unsaved changes.",
        maskClosable: true,
        okText: "Discard changes",
        okType: "danger",
        onOk() {
          onBack();
        },
        title: isAdding ? `Discard this ${name}?` : "Discard changes?",
      });
    } else {
      onBack();
    }
  }, [isAdding, isDirty, modal, name, onBack]);
  return (
    <Button
      aria-label="Cancel"
      danger
      icon={<CloseOutlined />}
      onClick={goBack}
      title="Cancel"
      type="text"
    />
  );
};
